var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.section},[_c('h3',{class:_vm.$style.title,domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('p',{class:_vm.$style.text,domProps:{"innerHTML":_vm._s(_vm.text)}}),_c('v-button',{attrs:{"size":"lg","color":"black-primary"},on:{"click":_vm.activate}},[_vm._v(" Activate Supster Business ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }